import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import FoldersTab from '../../components/File/FoldersTab'
import { ContainerFoldersQuery } from '../../__generated__/ContainerFoldersQuery.graphql'
import useLazyLoadQueryWithSubscription from '../../hooks/useLazyLoadQueryWithSubscription'

const ContainerFolders: React.FC<{ slug: string }> & { Skeleton: React.FC } = ({ slug }) => {
  const queryData = useLazyLoadQueryWithSubscription<ContainerFoldersQuery>(
    containerQuery,
    { slug },
    { subscriptionOptions: { entityType: 'containers', entitySlug: slug } }
  )

  return <FoldersTab folders={queryData.containerShow.folders} entityType='containers' entitySlug={slug} />
}

const containerQuery = graphql`
  query ContainerFoldersQuery($slug: String!) {
    containerShow(slug: $slug) {
      folders {
        ...FoldersTab_folders
      }
    }
  }
`

ContainerFolders.Skeleton = () => <FoldersTab.Skeleton />

export default ContainerFolders
